'use es6';

import { List } from 'immutable';
import { makeOperator } from './Operator';
export default makeOperator({
  name: 'NeverEqualAll',
  values: [{
    name: 'value',
    isValid: value => List.isList(value) && !value.isEmpty(),
    defaultValue: List()
  }, {
    name: 'isInexclusive',
    defaultValue: true
  }]
});